import { quietPost } from "src/pages/catalogue/api";
import { CheckDataIfExit, dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { SessionEnded } from "src/store/data/user/actionsUser";
import axios from "src/utils/axios";
import { PostFunction, friendlyErrorMessage } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

// Who each of a product's documents and questions is for (price/conditions,
// API migration 014). Both resolve to { ok, status, data, message } and
// never toast: the product screens say what happened where it happened.
async function conditionsPost(route, data, timeout) {
  try {
    const token = getLocalStorage(dataLocalStorage.userinfo)?.token ?? "";
    const res = await axios({ method: "post", url: route, data, headers: { Authorization: `Bearer ${token}` }, ...(timeout ? { timeout } : {}) });
    const body = res?.data ?? {};
    if (body.success === false) {
      // A refusal sent as a 200: read its sentence as a 4xx's.
      return { ok: false, status: res.status, message: friendlyErrorMessage({ response: { ...res, status: 400 } }) };
    }
    return { ok: true, status: res.status, data: body.data ?? null };
  } catch (err) {
    return { ok: false, status: err?.response?.status ?? null, timedOut: err?.code === "ECONNABORTED", message: friendlyErrorMessage(err) };
  }
}

/** The product's questions (with their choices), documents, conditions and age limits. */
export const GetConditions =
  ({ price_id, callback }) =>
  async (dispatch) => {
    const result = await conditionsPost(UrlApi.prices.conditions, { price_id: Number(price_id) });
    // The screen itself loaded, so a refused read means the session ended.
    if (result.status === 401) dispatch(SessionEnded());
    callback(result);
  };

/**
 * "This item applies when that question's answer is one of these values";
 * no question or no values: it applies to everyone again. A 401 here means
 * staff who can read but not edit, so it is shown, not a sign-out.
 */
export const SetCondition =
  ({ price_id, item_type, item_id, when_question_id, values, age, callback }) =>
  async () => {
    // By age ({ age_under?, age_at_least? }): the API finds the date of birth.
    if (age && (age.age_under != null || age.age_at_least != null)) {
      callback(await conditionsPost(UrlApi.prices.setCondition, { price_id: Number(price_id), item_type, item_id: Number(item_id), ...age }));
      return;
    }
    const some = Boolean(when_question_id) && values?.length > 0;
    const result = await conditionsPost(UrlApi.prices.setCondition, {
      price_id: Number(price_id),
      item_type,
      item_id: Number(item_id),
      when_question_id: some ? Number(when_question_id) : null,
      values: some ? values : [],
    });
    callback(result);
  };

/**
 * The standard set on this product: what adding it would do (apply false),
 * or add it (apply true). A 401 on apply means read-only staff: shown.
 */
export const StandardSet =
  ({ price_id, apply, callback }) =>
  async () => {
    callback(await conditionsPost(apply ? UrlApi.prices.applyStandardSet : UrlApi.prices.standardSet, { price_id: Number(price_id) }));
  };

/**
 * What the product's "Who can apply" needs on its form (migration 019): the
 * country of residence and "Which of these do you hold?" questions, and the
 * residence permit or visa copy asked of those it applies to. apply false:
 * what adding them would do.
 */
export const EligibilitySet =
  ({ price_id, apply, callback }) =>
  async () => {
    callback(await conditionsPost(apply ? UrlApi.prices.applyEligibilitySet : UrlApi.prices.eligibilitySet, { price_id: Number(price_id) }));
  };

/** What this product's embassy asks of one document; an empty note removes it. */
export const SetDocumentNote =
  ({ price_id, document_id, note, callback }) =>
  async () => {
    callback(await conditionsPost(UrlApi.prices.documentNote, { price_id: Number(price_id), document_id: Number(document_id), note: note ?? "" }));
  };

/** One product's rule on a document (migration 017): required, valid_months, valid_from, copy_kind; null: the document's own. */
export const SetDocumentRule =
  ({ price_id, document_id, rule, callback }) =>
  async () => {
    callback(await conditionsPost(UrlApi.prices.documentRule, { price_id: Number(price_id), document_id: Number(document_id), ...rule }));
  };

// Reading a checklist takes up to a minute (the page is read and the model
// reads it), longer than the usual 20 s request limit.
const EMBASSY_TIMEOUT_MS = 75000;

/**
 * Reads the embassy's checklist for this product: a link to a page or a PDF,
 * several links read together (source_urls, up to 5: the watched pages), or
 * its text.
 */
export const EmbassyRead =
  ({ price_id, source_url, source_urls, source_text, source_pages, callback }) =>
  async () => {
    const data = { price_id: Number(price_id) };
    if (source_url) data.source_url = source_url;
    if (source_urls?.length) data.source_urls = source_urls;
    if (source_text) data.source_text = source_text;
    // Pages sent from the Send to Safrati extension (browserPages.js).
    if (source_pages?.length) data.source_pages = source_pages;
    callback(await conditionsPost(UrlApi.prices.embassyCheck, data, EMBASSY_TIMEOUT_MS));
  };

/** Adds what staff ticked from the checklist. */
export const EmbassyApply =
  ({ price_id, documents, callback }) =>
  async () => {
    callback(await conditionsPost(UrlApi.prices.applyEmbassyCheck, { price_id: Number(price_id), documents }));
  };

export const GetAll =
  ({ callback, price_id }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.documents.getVisaTypeDocuments;
      let body = {
        price_id,
      };

      const response = await quietPost({
        data: body,
        route: link,
        dispatch,
      });
      callback(response);
      console.log({ err123: response });
    } catch (err) {
      callback(false);
    }
  };

export const ManageListDocument =
  ({ callback, document_id, editMode, price_id, quiet }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyData = {};

      // if (editMode) {
      //   bodyData.id = update_id;
      // }
      if (CheckDataIfExit(document_id)) {
        bodyData.document_id = document_id;
      }
      if (CheckDataIfExit(price_id)) {
        bodyData.price_id = price_id;
      }

      const response = await PostFunction({
        data: bodyData,
        Route: editMode
          ? UrlApi.visa_type_documents.edit
          : UrlApi.visa_type_documents.add,
        // quiet: the screen says what was saved, and what failed, itself.
        showalert: !quiet,
        showerror: !quiet,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false, err?.message);
    }
  };

export const Delete =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        idscontact_as: JSON.stringify(id),
      };
      const response = await PostFunction({
        data,
        Route: UrlApi.contact_as.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
